<template>
    <div class="resident-warpper">
        <div class="bg-white">
            <div class="flex align-center justify-between">
                <div class="flex-sub margin-right">
                    <div class="flex align-center ">
                        <div class="flex align-center margin-right-sm " v-if="[3].includes(user.power)">
                            <span>社区：</span>
                            <el-select v-model="xiangmu_id" placeholder="请选择社区" filterable clearable>
                                <el-option v-for="item in projectList" :key="item.id" :label="item.name"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="flex align-center margin-right-sm ">
                            <span>关键字：</span>
                            <el-input v-model="name" placeholder="请输入关键字" class="flex-sub"></el-input>
                        </div>
                        <el-button type="primary" @click="handleSearch">搜索</el-button>
                    </div>
                </div>
                <div>
                    <!--                    <el-button type="primary" @click="editItem(0)">添加人员</el-button>-->
                </div>

            </div>

            <div class="flex align-center justify-between margin-tb-sm">
                <div>
                    共{{ total }}条数据
                </div>
                <div>
                </div>
            </div>

            <el-table :data="lists" header-row-class-name="table-header" row-class-name="table-row" alig="center" border
                style="width: 100%">
                <el-table-column width="70" type="index" align="center" label="序号"></el-table-column>
                <el-table-column label="所属社区" prop="xiangmu_name"></el-table-column>
                <el-table-column label="姓名" prop="name"></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <el-table-column label="积分" prop="points"></el-table-column>
                <el-table-column label="创建时间" prop="create_time"></el-table-column>
                <el-table-column label="是否锁定" prop="is_lock">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.is_lock" :active-value="1" :inactive-value="0"
                            @change="changeShow($event, scope.row)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="330">
                    <template slot-scope="scope">
                        <div class="table-operate">
                            <el-button size="small" type="primary" @click="editItem(scope.row.id)">积分
                            </el-button>
                            <el-button size="small" type="primary" @click="delItem(scope.row.id)">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination v-if="lists.length > 0" class="page-all" background @current-change="getList"
                :current-page.sync="page" :page-size="limit" layout="prev, pager, next, jumper" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { getXiangMuList } from "@/api/common";
import { delUser, getUserList, setGoodLock } from "@/api/gzh";

export default {
    name: "shopping",
    components: {},
    data() {
        return {
            projectList: [],
            name: '',
            xiangmu_id: '',
            page: 1,
            limit: 10,
            total: 0,
            lists: [],
            shoppingOneKeyDialog: false
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
    },
    created() {
        this.$emit("setIndex", this.$route.path, "双暖为老 / 活动管理 / 人员管理", false);
        this.getList()
        this.getXiangMuList()
    },
    methods: {
        //  获取当前人员下的小区
        async getXiangMuList() {
            const project = await getXiangMuList()
            this.projectList = [{ name: '全部', id: 0 }, ...project.data]
        },
        //  商品删除
        delItem(id) {
            this.$confirm('您确定要删除该人员吗？', "温馨提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                cancelButtonClass: "msg-btn",
                confirmButtonClass: "msg-btn",
                center: true
            }).then(() => {
                this.sureDelete(id);
            });
        },
        async sureDelete(id) {
            let _state = await delUser(id);
            this.getList();
            this.$message.success(_state.info);
        },
        changeShow(val, row) {
            // this.$confirm(`您确定要${val?'上架':'下架'}该商品吗？`, "温馨提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     cancelButtonClass: "msg-btn",
            //     confirmButtonClass: "msg-btn",
            //     center: true
            // }).then(() => {
            // });
            this.setGoodLock(row.id);
        },
        async setGoodLock(id) {
            let _state = await setGoodLock(id);
            this.getList();
            this.$message.success(_state.info);
        },
        //  商品编辑
        editItem(id) {
            this.$router.push('/home/gzh/member/points/' + id)
        },
        //  搜索
        handleSearch() {
            this.page = 1
            this.getList()
        },
        //  获取商品列表
        async getList() {
            let _data = await getUserList(
                this.name,
                this.xiangmu_id,
                this.page,
                this.limit,
            )
            this.lists = _data.data
            this.total = _data.total_number
        }
    },
    filters: {},
    watch: {},
}
</script>

<style scoped lang="scss"></style>
